import keyMirror from 'keymirror'

export default keyMirror({
	'LOADED': null
}, 'ACTIVITY_LOG');
